import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
} from "@angular/core";
import { AlertService, AssociationRegistrationService } from "../../../services";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { DomSanitizer } from "@angular/platform-browser";
import * as lodash from "lodash";
import { ActivatedRoute } from "@angular/router";
import { AutoUnsubscribe, Store, AppFields, StorageUtil } from "../../../store";
import { CampaignService } from "../../../services/campaign.service";

@Component({
  selector: "app-new-messages-flyout",
  templateUrl: "./new-messages-flyout.component.html",
  styleUrls: ["./new-messages-flyout.component.css"]
})

@AutoUnsubscribe
export class NewMessagesFlyoutComponent implements OnInit, OnChanges {

  @Input() staffList: any[];
  @Input() parentChildList: any[];
  @Input() allClubTeams: any[];
  @Input() isTeamAccount: boolean;
  @Input() isCreateNewMassage: boolean;
  @Output() close = new EventEmitter();
  @Output() onCreateMessage: EventEmitter<any> = new EventEmitter();

  //campaign payload
  birthYears = [];
  campaignName = "";
  subject = "";
  from = "";
  allTeamsCopy: any;
  payload = {

    //Essentials
    messageTitle: '',

    //Filtering
    sendingMessageTo: "",
    //sendingMessageTo = 'TEAM'
    selectedTeamIds: [],
    selectedTeamRoleIds: [],
    gender: "b",
    //sendingMessageTo = 'TEAM'
    selectedStaffIds: [],
    selectedStaffRoleIds: [],

    //sendingMessageTo = 'PLAYER'
    playerGender: "b",
    playerCommitmentStatus: "-1",
    playerBirthYears: [],

    selectedParentUserIds: [],

    Notes: ""
  };

  //sendingMessageTo = Team
  // 1. Select Team(s)
  //public allClubTeams = [];
  public teamFields: Object = { text: "teamName", value: "teamId" };
  public staffFields: Object = { text: "name", value: "userID" };
  public parentFields: Object = { text: "name", value: "userID" };
  public mode: string;
  public placeholder = "Choose One Or Multiple";
  public isChange: boolean = false;

  // 2. Who Are You Sending To:
  sendEmailToTeamList = [
    // {name: 'All Staff', roleId: 0, checked:false},
    { name: "Head Coach", roleId: 3, checked: false },
    { name: "Assitant Coaches", roleId: 4, checked: false },
    { name: "Team Admins", roleId: 7, checked: false },
    // { name: "Players", roleId: 1, checked: false },
    { name: "Parent", roleId: 2, checked: false }
  ];

  //sendingMessageTo = Staff
  sendEmailToStaffList: any[] = [];

  playerCommitmentStatus: "";
  teamID = 0;
  teamGender;
  teamLogo: string;
  pageName: string;

  public clubId: number;
  isAllowed: boolean = false;

  constructor(
    private store: Store<any>,
  ) {
    this.mode = "CheckBox";

    for (let i = 0; i < 15; i++) {
      this.birthYears.push({ year: 2000 + i, checked: false });
    }

    this.resetNewCampaignFormPayload();
    this.store.select(AppFields.App, AppFields.MyTeam).subscribe(team => {
      if (team) {
        this.teamID = team.teamID;
        this.teamGender = team.gender || team.teamGender;
        this.pageName = team.teamName;
        this.teamLogo = team.clubLogo;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log("CommunicationCampaignFlyoutComponent ngOnChanges  = ", this.isCreateNewMassage);
    if (this.isCreateNewMassage == true) {
      this.resetNewCampaignFormPayload();
      this.clubId = +localStorage.getItem("clubId");
      this.getClubTeamsByClubId(this.clubId);
    }
  }

  ngOnInit(): void {
    // this.mode = "CheckBox";
    // console.log("CommunicationCampaignFlyoutComponent ngOnInit ");
    this.getTeamStaffList(this.teamID);

    this.sendEmailToStaffList = [
      { name: "Executive Directors", roleId: 25, checked: false, show: !this.isTeamAccount },
      { name: "Director of Coaching", roleId: 26, checked: false, show: !this.isTeamAccount },
      { name: "College Recruiter", roleId: 18, checked: false, show: !this.isTeamAccount },
      // {name: 'Age Coordinators', checked:false}, //todo - add role id
      { name: "Club Registrars", roleId: 17, checked: false, show: !this.isTeamAccount },
      { name: "Program Admins", roleId: 30, checked: false, show: !this.isTeamAccount },
      { name: "Club Treasures", roleId: 23, checked: false, show: !this.isTeamAccount },
      { name: "Head Coaches", roleId: 3, checked: false, show: true },
      { name: "Assistant Coaches", roleId: 4, checked: false, show: true },
      { name: "Team Admins", roleId: 7, checked: false, show: true }
    ];
  }

  onTeamSelected(event: any) {
    this.payload.selectedTeamIds.push(event.itemData.teamId);
    ///this.allTeamsStaffCopy = []
    this.staffCopy.map(x => {
      if (x.teamID == event.itemData.teamId) {
        this.allTeamsStaffCopy.push(x.userID);
      }
    });
  }

  onSelectAllTeams(e) {
    this.payload.selectedTeamIds = [];
    this.allTeamsStaffCopy = [];

    if (e.isChecked) {
      e.itemData.forEach(x => {
        this.payload.selectedTeamIds.push(x.teamId);

        this.staffCopy.map(s => {
          if (s.teamID == x.teamId) {
            this.allTeamsStaffCopy.push(s.userID);
          }
        });
      });
    }
  }

  onStaffSelected(e: any) {
    this.payload.selectedStaffIds.push(e.itemData.userID);
  }

  onStaffRemoved(item: any) {
    const index = this.payload.selectedStaffIds.indexOf(item.itemData.userID);
    if (index !== -1) {
      this.payload.selectedStaffIds.splice(index, 1);
    }
  }

  onSelectAllStaff(e) {
    this.payload.selectedStaffIds = [];
    if (e.isChecked) {

      this.payload.selectedStaffIds = e.itemData.map((obj) => obj.userID);
    }
  }

  onSelectAllParents(e) {
    this.payload.selectedParentUserIds = [];
    if (e.isChecked) {
      this.payload.selectedParentUserIds = e.itemData.map((obj) => obj.userID);
    }
  }

  onParentSelected(event: any) {
    this.payload.selectedParentUserIds.push(event.itemData.userID);
  }

  onParentRemoved(item: any) {
    const index = this.payload.selectedParentUserIds.indexOf(item.itemData.userID);
    if (index !== -1) {
      this.payload.selectedParentUserIds.splice(index, 1);
    }
  }

  onTeamRemoved(item: any) {
    const index = this.payload.selectedTeamIds.indexOf(item.itemData.teamId);
    if (index !== -1) {
      this.payload.selectedTeamIds.splice(index, 1);
      this.allTeamsStaffCopy = this.allTeamsStaffCopy.filter(x => x.teamID != item.itemData.teamId);
    }
  }

  onTeamSendingToSelected(roleId, event) {
    this.payload.selectedTeamRoleIds = this.sendEmailToTeamList
      .filter((opt) => opt["checked"])
      .map((opt) => opt.roleId);

    if (event.target.checked) {
      this.staffCopy.forEach(x => {
        if (x.roleList.filter(r => r.roleID == roleId).length > 0) {
          this.staff.push(x);
          this.allTeamsStaffCopy.push(x);
        }
      });
    } else {
      if (this.allTeamsStaffCopy.length > 0) {
        //this.allTeamsStaffCopy = this.allTeamsStaffCopy.filter(x => x.roleID != roleId);
        var staffLocal: any[] = this.allTeamsStaffCopy;
        this.allTeamsStaffCopy = [];

        staffLocal.forEach(x => {
          if (x.roleList.filter(r => r.roleID == roleId).length > 0) {
          }
          else {
            this.allTeamsStaffCopy.push(x);
          }
        });
      }
    }
  }

  onStaffSendingToSelected(roleId, event) {
    this.payload.selectedStaffRoleIds = this.sendEmailToStaffList
      .filter((opt) => opt["checked"])
      .map((opt) => opt.roleId);

    if (event.target.checked) {
      this.staffCopy.forEach(x => {
        if (x.roleList.filter(r => r.roleID == roleId).length > 0) {
          this.staff.push(x);
        }
      });
    } else {
      var staffLocal: any[] = this.staff;
      this.staff = [];

      staffLocal.forEach(x => {
        if (x.roleList.filter(r => r.roleID == roleId).length > 0) {
        }
        else {
          this.staff.push(x);
        }
      });
    }
    this.staff = lodash.unionBy(lodash.sortBy(this.staff.map(s => ({ ...s, name: s.lastName + ', ' + s.firstName })), 'name'), 'userID');
  }

  onPlayerBirthYearsChecked(event) {
    this.payload.playerBirthYears = this.birthYears
      .filter((opt) => opt["checked"])
      .map((opt) => opt.year);
  }

  genderSelectionChanged(event) {
    this.allClubTeams = this.allTeamsCopy;
    var _selectedGender = event.target.value;
    if (_selectedGender != "b") {
      this.allClubTeams = this.allTeamsCopy.filter(x => x.teamGender && x.teamGender.toLowerCase() == _selectedGender.toLowerCase());
    }
    // console.log("----------------------------------------")
    // console.log("FILTERED TEAMS  =>  ", this.allTeams);
    // console.log("----------------------------------------")
  }

  getClubTeamsByClubId(clubId: number) {
    this.allTeamsCopy = this.allClubTeams;
  }

  staff = [];
  staffCopy = [];
  allTeamsStaffCopy = [];

  getTeamStaffList(teamID: number) {
    //this.staff = this.staffList;
    this.staffCopy = this.staffList;

    this.staffCopy.map(x => {
      if (x.roleID && x.role) {
        this.staff.push(x);
      }
    });
  }

  sendingToChanged(event = null) {
    // console.log("sendingToChanged  ==  ", this.payload.sendingMessageTo);

    if (this.payload.sendingMessageTo == "Team") {
      this.sendEmailToTeamList.map((opt) => { opt.checked = true; });
      this.payload.selectedTeamRoleIds = this.sendEmailToTeamList
        .filter((opt) => opt["checked"])
        .map((opt) => opt.roleId);

    } else if (this.payload.sendingMessageTo == "Staff") {
      this.payload.selectedStaffIds.length = 0;
      this.sendEmailToStaffList.map((opt) => {
        opt.checked = true;
      });

      this.payload.selectedStaffRoleIds = this.sendEmailToStaffList
        .filter((opt) => opt["checked"])
        .map((opt) => opt.roleId);
    } else if (this.payload.sendingMessageTo == "Players") {

      this.birthYears.map((opt) => {
        opt.checked = true;
      });

      this.payload.playerBirthYears = this.birthYears
        .filter((opt) => opt["checked"])
        .map((opt) => opt.year);
    } else if (this.payload.sendingMessageTo == "Parent") {
      this.payload.selectedParentUserIds.length = 0;
    } else {
      // console.log("sendingToChanged  ==  ", this.payload.sendingMessageTo);
    }
  }

  onSend(event) {
    let InviteeList = [];
    if (this.payload.sendingMessageTo == "Parent") {
      let selectedParentUserIds = this.payload.selectedParentUserIds;
      InviteeList = this.setInvitedUserList(selectedParentUserIds, this.parentChildList, false);
    }
    if (this.payload.sendingMessageTo == "Staff") {
      let selectedStaffIds = this.payload.selectedStaffIds;
      InviteeList = this.setInvitedUserList(selectedStaffIds, this.staffCopy, false);
    }

    var data: any[] = [];
    if (this.isTeamAccount) {
      let ClubTeamID = StorageUtil.clubID + ":" + this.teamID;
      data.push({
        ClubID: StorageUtil.clubID,
        TeamID: this.teamID,
        ClubTeamID: ClubTeamID.toString(),
        CreatedDateTime: new Date().toJSON(),
        InviteeList: InviteeList,
        LastMessage: this.payload.Notes,
        LastMessageTime: new Date().toJSON(),
        GroupTitle: this.payload.messageTitle,
        CreatedByUserID: StorageUtil.userID,
        IsDeleted: false
      });
    } else {
      if (this.payload.sendingMessageTo != "Team") {
        data.push({
          ClubID: +StorageUtil.clubID,
          CreatedDateTime: new Date().toJSON(),
          InviteeList: InviteeList,
          LastMessage: this.payload.Notes,
          LastMessageTime: new Date().toJSON(),
          GroupTitle: this.payload.messageTitle,
          CreatedByUserID: StorageUtil.userID,
          IsDeleted: false
        });
      }
      else {
        //this.payload.selectedTeamIds.forEach(x => {
        //this.payload.selectedTeamRoleIds
        data.push({
          ClubID: StorageUtil.clubID,
          TeamList: this.setInvitedTeamList(this.payload.selectedTeamIds),
          CreatedDateTime: new Date().toJSON(),
          InviteeList: this.setInvitedUserList(this.payload.selectedTeamIds, this.staffList, true),
          LastMessage: this.payload.Notes,
          LastMessageTime: new Date().toJSON(),
          GroupTitle: this.payload.messageTitle,
          CreatedByUserID: StorageUtil.userID,
          IsDeleted: false
        });
        //});
        //InviteeList = this.setInvitedUserList(selectedTeamIds, this.allTeamsStaffCopy);
      }
    }

    var returnEvent: any = {
      isTeamChatMessage: (this.payload.sendingMessageTo == "Team") ? true : false,
      isAllowed: this.isAllowed,
      dataList: data
    };

    this.onCreateMessage.emit(returnEvent);
    this.onCancel(data);
  }

  allowMembersToReplyToTheMessage(e: boolean) {
    this.isAllowed = e;
  }

  setInvitedTeamList(teamIDList) {
    var invitedTeamList: any[] = [];
    teamIDList.forEach(teamID => {
      invitedTeamList.push({
        TeamID: teamID,
        IsDeleted: false
      })
    });

    return invitedTeamList;
  }

  setInvitedUserList(selectedList1, selectedList2, isTeam) {
    var InviteeList: any[] = [];
    InviteeList.push({
      UserID: +StorageUtil.userID,
      Role: +StorageUtil.roleId == 7 ? "Team Admin" : "Club Registrar",
      RoleID: +StorageUtil.roleId,
      TotalMessages: 0,
      IsDeleted: false,
      IsAllowed: true
    });

    if (isTeam) {
      selectedList1.map(x => {
        selectedList2.map(y => {
          if (y.teamInfo.filter(t => t.teamID == x).length > 0 && y.roleList.length > 0) {
            if (InviteeList.filter(z => z.UserID == y.userID).length == 0) {
              InviteeList.push({
                UserID: y.userID,
                Role: y.roleList.length == 1 ? y.roleList[0].role : "Multiple Role",
                RoleID: y.roleList.length == 1 ? y.roleList[0].roleID : -1,
                TotalMessages: 1,
                IsDeleted: false,
                IsAllowed: this.isAllowed
              });
            }
          }
        });
      });
    }
    else {
      selectedList1.map(x => {
        selectedList2.map(y => {
          if (y.userID == x && y.roleList.length > 0) {
            if (InviteeList.filter(z => z.UserID == y.userID).length == 0) {
              InviteeList.push({
                UserID: y.userID,
                Role: y.roleList.length == 1 ? y.roleList[0].role : "Multiple Role",
                RoleID: y.roleList.length == 1 ? y.roleList[0].roleID : -1,
                TotalMessages: 1,
                IsDeleted: false,
                IsAllowed: true
              });
            }
          }
        });
      });
    }

    return InviteeList;
  }
  onCancel(event) {
    this.close.emit();
  }

  resetNewCampaignFormPayload() {
    this.payload.sendingMessageTo = "";
    this.payload.selectedTeamIds = [];
    this.payload.selectedTeamRoleIds = [];
    this.payload.selectedStaffRoleIds = [];
    this.payload.playerGender = "b";
    this.payload.gender = "b";
    this.payload.playerCommitmentStatus = "-1";
    this.payload.playerBirthYears = [];
  }

  get isValid(): boolean {
    if (this.payload.sendingMessageTo == "") {
      return false;
    } else if (this.payload.messageTitle == "") {
      return false;
    }
    else if (this.payload.sendingMessageTo == "Team" && this.payload.selectedTeamIds.length == 0) {
      return false;
    } else if (this.payload.sendingMessageTo == "Staff" && this.payload.selectedStaffIds.length == 0) {
      return false;
    } else if (this.payload.sendingMessageTo == "Players" && this.payload.playerBirthYears.length == 0) {
      return false;
    }
    else if (this.payload.sendingMessageTo == "Parent" && this.payload.selectedParentUserIds.length == 0) {
      return false;
    } else if (this.payload.Notes == "") {
      return false;
    }
    else
      return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/sendgrid/new-messages-flyout/new-messages-flyout.component.ts